import { cn } from "@/lib/utils";

type Props = {
  children: React.ReactNode;
  optionalPadding?: string;
};

export const PanelContainer = ({ children, optionalPadding }: Props) => (
  <div
    className={cn(
      "touch-device:absolute flex flex-col items-center w-full overflow-x-hidden no-scrollbar overflow-y-hidden mobile:overflow-y-auto text-white bottom-[calc(var(--ad-gutter)+1rem)] top-6 sb-v2-lg:-top-2 sb-v2-lg:mt-0",
      optionalPadding ?? "sb-v2-lg:p-8",
    )}
  >
    {children}
  </div>
);
